import React from "react";

const CircleMenuButton = ({ label, icon, onClick, id }) => {
  return (
    <div id={id} className="circle-button" onClick={() => onClick(label)}>
      {icon == true ? (
        <img
          className={`menuPerkIcon`}
          src={require("./perks/" + label + ".png")}
        />
      ) : (
        <div>{label}</div>
      )}
    </div>
  );
};

export default CircleMenuButton;
